import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
    position: relative;
    width: ${p => p.$width || "100%"};
    max-width: ${p => p.$maxWidth};
    margin: ${p => p.$margin};
    display: ${p => p.$display};
`;

const Icon = styled.img`
    position: absolute;
    top: 50%;
    left: ${p => p.$position === "left" ? p.$offset : "auto"};
    right: ${p => p.$position === "right" ? p.$offset : "auto"};
    width: ${p => p.$width};
    height: ${p => p.$height};
    transform: translateY(-50%);
    pointer-events: none;
    z-index: 1;
`;

const TextInputWithIcon = ({
    children,
    className,
    display,
    iconAlt = "",
    iconHeight = "1rem",
    iconOffset = "16px",
    iconPosition = "left",
    iconSrc,
    iconWidth = "1rem",
    margin,
    maxWidth,
    style,
    width = "100%"
}) => {
    return (
        <Wrapper
            className={className}
            style={style}
            $display={display}
            $margin={margin}
            $maxWidth={maxWidth}
            $width={width}
        >
            <Icon
                alt={iconAlt}
                src={iconSrc}
                $height={iconHeight}
                $offset={iconOffset}
                $position={iconPosition}
                $width={iconWidth}
            />
            {children}
        </Wrapper>
    );
};

export default TextInputWithIcon;
